









































import { Component, Vue } from 'vue-property-decorator';

import { Aggreements } from '@/enums/Aggreements';
import { Store } from '@/enums/Store';

import { NamedOption } from '@/util/NamedOption';

import { namespace } from 'vuex-class';

import { extend } from 'vee-validate';
import { is } from 'vee-validate/dist/rules';

import FormGroup from '@/components/Form/InputComponents/FormGroup.vue';
import FormCheckbox from '@/components/Form/InputComponents/FormCheckbox.vue';
import Validatable from '@/components/Validatable.vue';

const APP = namespace(Store.APP);

@Component({
  components: { FormCheckbox, FormGroup }
})
export default class Agreements extends Validatable {
  @APP.Mutation('ADD_ERROR') addError!: (error: Error) => void;
  @APP.State('promoterId') promoterId!: number;

  privacyOption?: NamedOption;
  conditionsOption?: NamedOption;
  paymentOption?: NamedOption;
  subscriptionAgreement?: NamedOption;

  privacy = false;
  conditions = false;
  payment = false;
  subscription = false;

  rules = { is: { other: true } };

  created(): void {
    extend('is', {
      ...is,
      message: this.$t('agreement-invalid').toString()
    });

    this.paymentOption = new NamedOption(
      this.$t('payment-option').toString(),
      true,
      'payment-option'
    );

    if (this.promoterId == 850) {
      this.subscriptionAgreement = new NamedOption(
        this.$t('jumi-subscription-agreement').toString(),
        true,
        'subscription-agreement'
      );

      this.privacyOption = new NamedOption('jumi-privacy-option', true, 'privacy-option');

      this.conditionsOption = new NamedOption(
        'jumi-conditions-option',
        true,
        'conditions-option'
      );
    } else {
      this.subscriptionAgreement = new NamedOption(
        this.$t('subscription-agreement').toString(),
        true,
        'subscription-agreement'
      );

      this.privacyOption = new NamedOption('privacy-option', true, 'privacy-option');

      this.conditionsOption = new NamedOption(
        'conditions-option',
        true,
        'conditions-option'
      );
    }
  }

  get conditionsLink(): string {
    if (this.promoterId == 850) {
      return 'https://www.wiedenest.de/agb';
    }

    return 'https://k5-leitertraining.de/legal/agb/';
  }

  get conditionsLinkLabel() {
    if (this.promoterId == 850) {
      return 'jumi-conditions-link-label';
    }

    return 'conditions-link-label';
  }

  get privacyAgreementLink() {
    if (this.promoterId == 850) {
      return 'https://www.wiedenest.de/datenschutz';
    }

    return 'https://k5-leitertraining.de/legal/datenschutz/';
  }

  get privacyLinkLabel() {
    if (this.promoterId == 850) {
      return 'jumi-privacy-link-label';
    }

    return 'privacy-link-label';
  }
}
